// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M2 2H22V22L2 22V2ZM13 6.5H11V11L6.5 11V13L11 13V17.5H13V13H17.5V11H13V6.5Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-add-rectangle-filled')
export default class AddRectangleFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'add-rectangle-filled',
    }
  }
}
